<ng-container>
  <a
    href="#"
    [attr.class]="iconClass"
    [attr.aria-label]="getLabel()"
    (click)="invertVisibility($event)"
    [attr.tabindex]="tabindex"
    [attr.data-test-id]="dataTestID"
    >{{ getLabel() }}</a
  >
  <span class="sr-only" aria-live="polite" role="alert">{{ getLabel() }}</span>
</ng-container>
